<script setup>
import { TooltipProvider, useForwardProps } from "reka-ui";

const props = defineProps({
  delayDuration: { type: Number, required: false },
  skipDelayDuration: { type: Number, required: false },
  disableHoverableContent: { type: Boolean, required: false },
  disableClosingTrigger: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  ignoreNonKeyboardFocus: { type: Boolean, required: false },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <TooltipProvider data-slot="tooltip-provider" v-bind="forwarded">
    <slot />
  </TooltipProvider>
</template>
